import React from 'react';
import { TypographySmall } from '@/Components/shadcn';

interface StatusCounterProps {
    status: string;
    count: number;
}
function StatusCounter({ status, count }: StatusCounterProps): React.JSX.Element {
    return (
        <div className="bg-muted flex basis-1/4 flex-col items-center justify-between rounded-xl pb-5">
            <div className="flex h-full flex-col items-center justify-between gap-1" data-cy={`${status}Counter`}>
                <TypographySmall className="text-muted-foreground" data-cy={`${status}Status`}>
                    {status}
                </TypographySmall>
                <span className="text-foreground text-3xl font-semibold tracking-tight" data-cy={`${status}Count`}>
                    {count}
                </span>
            </div>
        </div>
    );
}

export default StatusCounter;
